<template>
	<div id="create-properties">
		<vs-row>
			<vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
				<vs-input v-model="property.name" class="w-full" :label="$t('Teams.Form.Label')" />
			</vs-col>
			<vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
				<vs-input v-model="property.label" class="w-full" :label="$t('Teams.Form.Name')" />
			</vs-col>
			<vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
				<div class="w-full">
					<label class="vs-input--label">{{ $t("Teams.Form.Type") }}</label>
					<v-select v-model="property.type" :options="type" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false">
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
							<template v-else>
								{{ $t("NoResultsFound") }}
							</template>
						</template>
					</v-select>
				</div>
			</vs-col>
			<vs-col class="p-2" vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="2">
				<vs-button class="w-full" color="primary" type="filled" @click="addProperty()">{{
					$t("Teams.Form.Add")
				}}</vs-button>
			</vs-col>
		</vs-row>

		<vs-table class="w-full" :data="properties">
			<template slot="thead">
				<vs-th>{{ $t("Teams.Form.Label") }}</vs-th>
				<vs-th>{{ $t("Teams.Form.Name") }}</vs-th>
				<vs-th>{{ $t("Teams.Form.Type") }}</vs-th>
				<vs-th>{{ $t("Teams.Table.Action") }}</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data">
					<vs-td :data="data[indextr].name">
						{{ data[indextr].name }}
					</vs-td>
					<vs-td :data="data[indextr].label">
						{{ data[indextr].label }}
					</vs-td>
					<vs-td :data="data[indextr].type">
						{{ data[indextr].type.value || data[indextr].type }}
					</vs-td>
					<vs-td :data="data[indextr].type">
						<vs-button
							color="danger"
							type="border"
							icon-pack="feather"
							icon="icon-trash"
							@click="deleteItem(indextr)"
						></vs-button>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>
<script type="text/javascript">
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {Spanish as SpanishLocale} from "flatpickr/dist/l10n/es.js";

export default {
	data() {
		return {
			properties: [],
			property: {
				name: "",
				label: "",
				type: "text",
				value: "",
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "DateTime",
					value: "datetime",
				},
				{
					label: "Number",
					value: "number",
				},
			],
			configdateTimePicker: {
				enableTime: true,
				dateFormat: "d-M-Y H:i",
				locale: SpanishLocale,
			},
		};
	},
	props: {
		addPropertie: Function,
		deletePropertie: Function,
		isUpdate: Boolean,
		data: Array,
	},
	methods: {
		addProperty() {
			if (this.property.label !== "" && this.property.name !== "") {
				const object = {
					label: this.property.label,
					name: this.property.name,
					type: this.property.type,
				};
				this.properties.push(object);
				this.addPropertie(object);
				// Empty fields
				this.property = {
					name: "",
					label: "",
					type: {value: "text", label: "text"},
					value: "",
				};
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Warning"),
					text: this.$t("Teams.Form.ValidMessages.AddProperty"),
				});
			}
		},
		deleteItem(indexItem) {
			this.properties.splice(indexItem, 1);
			this.deletePropertie(indexItem);
		},
	},
	components: {
		"v-select": vSelect,
		flatPickr,
	},
	mounted() {
		if (this.isUpdate && this.data) {
			this.properties = this.data;
		}
	},
};
</script>
<style type="text/css">
#create-properties .vs__dropdown-toggle {
	background: white;
}
</style>
